/** Short absolute timestamp, e.g. "Jun 1, 16:09". Accepts ms or ISO string. */
export function fmtWhen(ts: number | string | null | undefined): string {
  if (ts === null || ts === undefined) return '—';
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** Human-readable byte size, e.g. "1.4 MB". */
export function fmtBytes(n: number | null | undefined): string {
  if (!n || n < 0) return '—';
  const units = ['B', 'KB', 'MB', 'GB'];
  let v = n;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i++;
  }
  return `${v.toFixed(v < 10 && i > 0 ? 1 : 0)} ${units[i]}`;
}

/** ms duration → "1.2s" / "340ms". */
export function fmtDuration(ms: number | null | undefined): string {
  if (ms === null || ms === undefined) return '—';
  return ms >= 1000 ? `${(ms / 1000).toFixed(1)}s` : `${ms}ms`;
}

/**
 * Approve auto-provisions the data store best-effort; a failure comes back in
 * the response rather than as an HTTP error. Turn it into a thrown Error so the
 * action toast shows it — an approved-but-unprovisioned account rejects every
 * upload (Eterna, 2026-09-25).
 */
export function assertProvisioned(p: { provisioned: boolean; error?: string } | undefined): void {
  if (p && !p.provisioned) {
    throw new Error(
      `Approved, but auto-provisioning failed: ${p.error ?? 'unknown error'}. Open Details and click Provision.`,
    );
  }
}
